export const SUGGESTION_DATA_REQUEST="SUGGESTION_DATA_REQUEST";
export const SUGGESTION_DATA_SUCCESS="SUGGESTION_DATA_SUCCESS";
export const SUGGESTION_DATA_FAILURE="SUGGESTION_DATA_FAILURE";

export const QUERY_DATA_SUCCESS="SUGGESTION_DATA_SUCCESS";


